import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { ColumnDirective, ColumnsDirective, GridComponent, Inject, Page, Toolbar, Sort } from '@syncfusion/ej2-react-grids';
import { L10n } from '@syncfusion/ej2-base';
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCadastrarAvaliacao from '../../components/modal/ModalCadastrarAvaliacao';
import ModalEditarAvaliacao from '../../components/modal/ModalEditarAvaliacao';
import ModalExcluirAvaliacao from '../../components/modal/ModalExcluirAvaliacao';
import LoadingScreen from '../../components/LoadingScreen';
import Tabela from '../../components/Tabela';

function Avaliacao() {
    const { Success, Error, openModal, setOpenModal, AvaliacaoConsulta, ListaAvaliacaoConsulta, modalEditarAvaliacao, setModalEditarAvaliacao, setAvaliacaoEdicao, setAvaliacaoAtualKey, modalExcluirAvaliacao, setModalExcluirAvaliacao, Loading, ListaFiltroAvaliacao, totalRegistrosAvaliacao, filtroAvaliacao, totalRegistrosFiltroAvaliacao, InativarAvaliacao } = useContext(ApiContext)
    const { Permissao } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditAvaliacao = (props) => {
        setModalEditarAvaliacao(true)
        setAvaliacaoAtualKey(props.key)
        setAvaliacaoEdicao(props)
    }

    const DeletarAvaliacao = (props) => {
        setAvaliacaoAtualKey(props.key)
        setModalExcluirAvaliacao(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroAvaliacao(searchTerm, currentPage, pageSize);
        } else {
            ListaAvaliacaoConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroAvaliacao : totalRegistrosAvaliacao;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar avaliação'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarAvaliacao &&
                <ModalEditarAvaliacao currentPage={currentPage} />
            }
            {modalExcluirAvaliacao &&
                <ModalExcluirAvaliacao currentPage={currentPage} />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            {Loading &&
                <LoadingScreen />
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarAvaliacao closeModal={setOpenModal} currentPage={currentPage} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar avaliação</button>
                    }
                </div>
                <div className='card card-table'>
                    <h3 className='h3-demanda' style={h3Demanda}>Avaliações cadastradas</h3>
                    <Tabela
                        data={searchTerm.trim() !== "" ? filtroAvaliacao : AvaliacaoConsulta}
                        columns={[
                            { label: "Avaliação", field: "descricao", width: "40%" },
                              {
                                label: "Ativo",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                        <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => InativarAvaliacao(x.key, !x.ativo)} checked={x.ativo} />
                                    </div>
                                ),
                            },
                            {
                                label: "Opções",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <button onClick={() => EditAvaliacao(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                            <TbPencil />
                                        </button>
                                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                            <button onClick={() => DeletarAvaliacao(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbTrash />
                                            </button>
                                        }
                                    </div>
                                ),
                            },
                        ]}
                        loading={Loading}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        onSearch={(term) => {
                            setCurrentPage(1);
                            if (term.trim() !== "") {
                                ListaFiltroAvaliacao(term, 1, 10);
                            } else {
                                ListaAvaliacaoConsulta(1, 10);
                            }
                        }}
                        corTerciaria={corTerciaria}
                    />
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
}

export default Avaliacao;